export default (function (value) {
  return value.toString();
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/toString.js
// module id = 693
// module chunks = 1